module.exports = __webpack_public_path__ + "img/wallet.39284814.jpg";